// File: src/components/enum/financialEnums.ts

export enum FinancialEntryType {
  INCOME = "INCOME",
  EXPENSE = "EXPENSE",
}

export const FinancialEntryTypeLabel: Record<FinancialEntryType, string> = {
  [FinancialEntryType.INCOME]: "Entrada",
  [FinancialEntryType.EXPENSE]: "Saída",
};

export enum FinancialEntryStatus {
  PENDING = "PENDING",
  SETTLED = "SETTLED",
  OVERDUE = "OVERDUE",
  CANCELED = "CANCELED",
}

export const FinancialEntryStatusLabel: Record<FinancialEntryStatus, string> = {
  [FinancialEntryStatus.PENDING]: "Pendente",
  [FinancialEntryStatus.SETTLED]: "Liquidado",
  [FinancialEntryStatus.OVERDUE]: "Vencido",
  [FinancialEntryStatus.CANCELED]: "Cancelado",
};

export const FinancialEntryStatusColor: Record<FinancialEntryStatus, string> = {
  [FinancialEntryStatus.PENDING]: "#fbbf24",
  [FinancialEntryStatus.SETTLED]: "#34d399",
  [FinancialEntryStatus.OVERDUE]: "#fb7185",
  [FinancialEntryStatus.CANCELED]: "#808080",
};

export enum FinancialPaymentMethod {
  PIX = "PIX",
  CASH = "CASH",
  CARD = "CARD",
  BANK_SLIP = "BANK_SLIP",
  TRANSFER = "TRANSFER",
  OTHER = "OTHER",
}

export const FinancialPaymentMethodLabel: Record<FinancialPaymentMethod, string> = {
  [FinancialPaymentMethod.PIX]: "Pix",
  [FinancialPaymentMethod.CASH]: "Dinheiro",
  [FinancialPaymentMethod.CARD]: "Cartão",
  [FinancialPaymentMethod.BANK_SLIP]: "Boleto",
  [FinancialPaymentMethod.TRANSFER]: "Transferência",
  [FinancialPaymentMethod.OTHER]: "Outro",
};
